<template>
  <rest-list-action
    icon="el-icon-video-play"
    :title="$t('RestList_Action_Start')"
    :click="click"
  />
</template>

<script>
import RestApi from '@/core/services/RestApi'
import RestListAction from '@/common/components/rest/RestListAction'
import { EventBus } from '@/core/EventBus'

export default {
  name: 'RestListActionStart',
  components: { RestListAction },
  inject: ['restList'],

  props: {
    endpoint: {
      type: Object,
      required: true
    }
  },

  methods: {
    click() {
      this.$msgbox({
        title: this.$t('RestList_StartTitle'),
        message: this.$t('RestList_StartPrompt', { label: this.name }),
        showCancelButton: true,
        confirmButtonText: this.$t('RestList_StartConfirmButton'),
        cancelButtonText: this.$t('RestList_StartCancelButton'),
        center: true
      }).then(() => {
        this.restList.loading = true
        RestApi(this.endpoint)
          .then(() => {
            this.$message({
              message: this.$t('RestList_StartSuccessMessage'),
              type: 'success'
            })
            EventBus.$emit('refreshStopAll')
            this.restList.refresh()
            this.restList.loading = false
          })
          .catch(error => {
            this.restList.loading = false
            this.$message({
              message: error.message,
              type: 'error'
            })
          })
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/modules/campaigns/components/RestListActionStart.vue